import { Injectable } from '@angular/core';
import { CustomerAccount } from '@dch/common-business-logic';
import {
  CookieService,
  CustomerService,
  EnvironmentService,
} from '@dch/ng-common';
import { Observable, of, throwError } from 'rxjs';
import {
  BILL_AUTH_LAT_COOKIE_VALUE,
  BILL_AUTH_COOKIE_KEY,
  SMOOTH_AUTHENTICATION_SESSION_STORAGE_KEY,
  BILL_AUTH_MPXS_COOKIE_VALUE,
} from '../config/my-bill.constants';

@Injectable()
export class BillingCustomerService {
  constructor(
    private customerService: CustomerService,
    private environmentService: EnvironmentService,
    private cookieService: CookieService
  ) {}

  getCustomerAccount(): Observable<CustomerAccount> {
    if (
      this.environmentService.isSmoothAccess &&
      BILL_AUTH_LAT_COOKIE_VALUE ===
        this.cookieService.getCookie(BILL_AUTH_COOKIE_KEY)
    ) {
      return this.getCustomerAccountForSmoothAccess();
    } else {
      // remove smooth authentication session storage data when user is authenticated
      if (
        sessionStorage.getItem(SMOOTH_AUTHENTICATION_SESSION_STORAGE_KEY) !==
        null
      ) {
        sessionStorage.removeItem(SMOOTH_AUTHENTICATION_SESSION_STORAGE_KEY);
      }
      // update myproximus authentication in the cookie
      if (
        BILL_AUTH_LAT_COOKIE_VALUE ===
        this.cookieService.getCookie(BILL_AUTH_COOKIE_KEY)
      ) {
        this.cookieService.setCookie(
          BILL_AUTH_COOKIE_KEY,
          BILL_AUTH_MPXS_COOKIE_VALUE,
          1
        );
      }
      return this.customerService.getCustomerAccount();
    }
  }

  private getCustomerAccountForSmoothAccess(): Observable<CustomerAccount> {
    try {
      const customerInfoFromSessionStorage: any = JSON.parse(
        sessionStorage.getItem(SMOOTH_AUTHENTICATION_SESSION_STORAGE_KEY)
      );
      const customerId = customerInfoFromSessionStorage.cid;
      // build fake customer response for the smooth access user to align with customerAccount response
      const fakeCustomerResponse = {
        oneCDB: true,
        _embedded: {
          'us:fls-default-customer': {
            subsegment: customerInfoFromSessionStorage.segment,
            customerId: customerId,
            payer: true,
          },
        },
      };
      return of(new CustomerAccount(fakeCustomerResponse, customerId));
    } catch (error) {
      return throwError('user is not authenticated');
    }
  }
}
